import { render, staticRenderFns } from "./ImageMessagePreview.vue?vue&type=template&id=b9bece64&scoped=true&"
import script from "./ImageMessagePreview.vue?vue&type=script&lang=js&"
export * from "./ImageMessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./ImageMessagePreview.vue?vue&type=style&index=0&id=b9bece64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bece64",
  null
  
)

export default component.exports